// ── AR Flow — NOVA INTERFACE: 📦 Entregas (a partir do LIFT) ─────────────────
// Colunas: Na fábrica → No depósito · agendar → Pronta entrega → Entregue.
// Cada card separa, com rótulos diferentes, o que é CERTEZA (status do LIFT),
// o que é PREVISÃO (do fornecedor) e o que é DEDUÇÃO do CRM.
// Só leitura: não grava nada. O clique abre a conversa do cliente na aba de origem.

import { useMemo, useState } from "react";
import { COLUNAS, montarEntregas, pedidosDaVisao } from "./entregasModel.mjs";
import LiftCrmClientAction from "../LiftCrmClientActions";

const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const DISPLAY = "'Bricolage Grotesque', 'Source Sans 3', system-ui, sans-serif";
const dm = v => (v ? v.slice(0, 10).split("-").reverse().slice(0, 2).join("/") : "—");
const brl = v => (v == null || v === "" ? "" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }));

function Card({ th, item, mostrarConsultor, nomeConsultor, onAbrir }) {
  const line = th.nuLine || th.sandDark;
  const { pedido: p, info } = item;
  const [aberto, setAberto] = useState(false);
  const itens = Array.isArray(p.itens) ? p.itens : [];
  const resumo = itens.map(i => i.produto || i.produtoLift).filter(Boolean);
  const consultor = nomeConsultor(p.vendidoPor?.consultantId ?? p.responsavelId);
  const podeAbrir = Boolean(onAbrir && p.cliente?.telefone);
  return (
    <div style={{ background: "#fff", border: `1px solid ${line}`, borderRadius: 4, marginBottom: 8 }}>
      <button type="button" onClick={() => podeAbrir ? onAbrir(p) : setAberto(a => !a)} style={{ width: "100%", textAlign: "left", background: "none", border: "none", padding: "10px 12px 8px", cursor: "pointer", fontFamily: "inherit", color: th.text }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "baseline" }}>
          <span style={{ fontWeight: 700, fontSize: 14 }}>{p.cliente?.nome || "Cliente"}</span>
          <span style={{ fontFamily: MONO, fontSize: 11, color: th.muted }}>#{p.liftPedidoId}</span>
        </div>
        {resumo.length > 0 && <div style={{ fontSize: 12, color: th.muted, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{resumo.join(" · ")}</div>}
        {mostrarConsultor && consultor && <div style={{ fontSize: 12, color: th.muted }}>{consultor}{p.loja ? ` · ${p.loja}` : ""}</div>}
        <div style={{ display: "flex", flexDirection: "column", gap: 2, marginTop: 6, fontSize: 12 }}>
          <span><span style={{ color: th.muted }}>Status no LIFT: </span><strong>{info.status}</strong></span>
          {info.coluna !== "entregue" && <span><span style={{ color: th.muted }}>Previsão do fornecedor: </span>{dm(info.previsao)}</span>}
          {info.chegou && <span style={{ color: th.muted }}>Chegada percebida pelo CRM em {dm(info.chegou)}</span>}
          {info.coluna === "entregue" && info.entregaManualEm && <span style={{ color: th.muted }}>Entrega confirmada pela loja em {dm(info.entregaManualEm)}</span>}
          {info.coluna === "entregue" && !info.entregaManualEm && info.entregueEm && <span style={{ color: th.muted }}>Entrega percebida pelo CRM em {dm(info.entregueEm)}</span>}
        </div>
        {info.alertas.map(a => (
          <div key={a.texto} role="status" style={{ marginTop: 6, fontSize: 12, fontWeight: 700, color: a.nivel === "alto" ? "#991B1B" : "#92400E", background: a.nivel === "alto" ? "#FEF2F2" : "#FFFBEB", borderRadius: 4, padding: "4px 7px" }}>
            {a.nivel === "alto" ? "⚠️" : "⏰"} {a.texto}
          </div>
        ))}
      </button>
      <div style={{ padding: "0 12px" }}>
        <LiftCrmClientAction storeId={p.storeId} pedido={p.liftPedidoId} sale={p} theme={th} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 12px 8px" }}>
        <span style={{ fontFamily: MONO, fontSize: 12, color: th.text }}>{brl(p.valorTotal)}</span>
        {itens.length > 0 && (
          <button type="button" onClick={() => setAberto(a => !a)} aria-expanded={aberto} style={{ background: "none", border: "none", color: th.accent, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
            {aberto ? "Esconder itens" : `Ver ${itens.length} ite${itens.length === 1 ? "m" : "ns"}`}
          </button>
        )}
      </div>
      {aberto && (
        <div style={{ borderTop: `1px solid ${line}`, padding: "6px 12px 10px" }}>
          {itens.map((i, n) => (
            <div key={i.codigoItemLift || n} style={{ fontSize: 12, padding: "4px 0", borderBottom: n < itens.length - 1 ? `1px dashed ${line}` : "none" }}>
              <div style={{ fontWeight: 700 }}>{i.quantidade ? `${i.quantidade}× ` : ""}{i.produto || i.produtoLift}</div>
              <div style={{ color: th.muted }}>{[i.fornecedor, i.situacao && `situação: ${i.situacao}`, i.previsaoEntrega && `previsão: ${dm(i.previsaoEntrega)}`, i.ordemCompra && `OC ${i.ordemCompra}`].filter(Boolean).join(" · ")}</div>
            </div>
          ))}
          {p.entrega?.transportadora && <div style={{ fontSize: 12, color: th.muted, marginTop: 4 }}>Transportadora: {p.entrega.transportadora}</div>}
        </div>
      )}
    </div>
  );
}

export default function Entregas({ theme, pedidos, hoje, carregado, erro, usuario, mostrarConsultor, nomeConsultor = () => "", onAbrir, onListaAntiga }) {
  const th = theme;
  const line = th.nuLine || th.sandDark;
  const [busca, setBusca] = useState("");
  const [soAlertas, setSoAlertas] = useState(false);
  const colunas = useMemo(() => montarEntregas(pedidosDaVisao(pedidos, usuario), hoje), [pedidos, hoje, usuario]);
  const filtrar = lista => lista.filter(x => (!soAlertas || x.info.alertas.length)
    && (!busca.trim() || `${x.pedido.cliente?.nome || ""} ${x.pedido.liftPedidoId}`.toLowerCase().includes(busca.trim().toLowerCase())));
  const totalAlertas = Object.values(colunas).flat().filter(x => x.info.alertas.length).length;
  const visiveis = COLUNAS.filter(c => c.id !== "outros" || colunas.outros.length);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
        <div>
          <div style={{ fontFamily: DISPLAY, fontSize: 26, fontWeight: 700, color: th.text }}>Entregas</div>
          <div style={{ fontSize: 14, color: th.muted }}>Pedidos do LIFT, da fábrica até a casa do cliente.</div>
        </div>
        {onListaAntiga && <button type="button" onClick={onListaAntiga} style={{ background: "none", border: `1px solid ${line}`, borderRadius: 4, padding: "6px 10px", fontSize: 13, cursor: "pointer", fontFamily: "inherit", color: th.text }}>Entregas registradas no CRM (lista antiga)</button>}
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", margin: "12px 0" }}>
        <input aria-label="Buscar cliente ou pedido" value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar cliente ou nº do pedido" style={{ padding: "7px 10px", borderRadius: 4, border: `1px solid ${line}`, fontFamily: "inherit", fontSize: 14, minWidth: 220 }} />
        <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 14, color: th.text }}>
          <input type="checkbox" checked={soAlertas} onChange={e => setSoAlertas(e.target.checked)} /> Só com aviso ({totalAlertas})
        </label>
      </div>
      <div style={{ fontSize: 12, color: th.muted, marginBottom: 10 }}>
        <strong>Status no LIFT</strong> é o que o LIFT informa. <strong>Previsão</strong> é a data que o fornecedor passou, não uma data combinada. <strong>Entrega confirmada pela loja</strong> usa a data real informada pelo depósito; <strong>"percebida pelo CRM"</strong> é apenas quando o CRM notou a mudança de status.
      </div>
      {erro && <div role="alert" style={{ color: "#991B1B", fontSize: 14, marginBottom: 10 }}>Não foi possível carregar os pedidos do LIFT agora.</div>}
      {!carregado && !erro && <div style={{ color: th.muted, fontSize: 14 }}>Carregando pedidos do LIFT…</div>}
      {carregado && (
        <div style={{ display: "grid", gridTemplateColumns: `repeat(${visiveis.length}, minmax(230px, 1fr))`, gap: 12, overflowX: "auto", paddingBottom: 8 }}>
          {visiveis.map(c => {
            const lista = filtrar(colunas[c.id]);
            return (
              <section key={c.id} aria-label={c.titulo} style={{ minWidth: 230 }}>
                <div style={{ borderTop: `3px solid ${c.cor}`, background: th.sandDark, borderRadius: "4px 4px 0 0", padding: "8px 10px", marginBottom: 8 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                    <span style={{ fontWeight: 700, fontSize: 14, color: th.text }}>{c.titulo}</span>
                    <span style={{ fontFamily: MONO, fontSize: 13, color: c.cor }}>{lista.length}</span>
                  </div>
                  <div style={{ fontSize: 11, color: th.muted }}>{c.desc}</div>
                </div>
                {lista.length === 0 && <div style={{ fontSize: 13, color: th.muted, padding: "4px 2px" }}>Nenhum pedido.</div>}
                {lista.map(item => <Card key={`${item.pedido.storeId}-${item.pedido.liftPedidoId}`} th={th} item={item} mostrarConsultor={mostrarConsultor} nomeConsultor={nomeConsultor} onAbrir={onAbrir} />)}
              </section>
            );
          })}
        </div>
      )}
    </div>
  );
}
